export var BuyerResearchStage;
(function (BuyerResearchStage) {
    BuyerResearchStage["Unspecified"] = "unspecified";
    BuyerResearchStage["Decision"] = "Decision";
    BuyerResearchStage["Consideration"] = "Consideration";
    BuyerResearchStage["Interest"] = "Interest";
    BuyerResearchStage["Awareness"] = "Awareness";
    BuyerResearchStage["All"] = "All";
    BuyerResearchStage["NoData"] = "No Data";
})(BuyerResearchStage || (BuyerResearchStage = {}));
export var BuyerResearchStageWithNonActive;
(function (BuyerResearchStageWithNonActive) {
    BuyerResearchStageWithNonActive["Decision"] = "Decision";
    BuyerResearchStageWithNonActive["Consideration"] = "Consideration";
    BuyerResearchStageWithNonActive["Interest"] = "Interest";
    BuyerResearchStageWithNonActive["Awareness"] = "Awareness";
    BuyerResearchStageWithNonActive["NonActive"] = "Non-Active";
})(BuyerResearchStageWithNonActive || (BuyerResearchStageWithNonActive = {}));
export var BuyerResearchStageMap = {
    Decision: 1,
    Consideration: 2,
    Interest: 3,
    Awareness: 4,
    'No Data': 5,
};
export var BuyerResearchStageRank = {
    Decision: 4,
    Consideration: 3,
    Interest: 2,
    Awareness: 1,
    'No Data': 0,
};
export var brsOptions = Object.values(BuyerResearchStage)
    .filter(function (buyerResearchStage) {
    return !['unspecified', 'No Data', 'All'].includes(buyerResearchStage);
})
    .map(function (buyerResearchStage) { return ({
    value: buyerResearchStage,
    label: buyerResearchStage,
}); });
export var brsOptionsWithNonActive = Object.values(BuyerResearchStageWithNonActive).map(function (buyerResearchStage) { return ({
    value: buyerResearchStage,
    label: buyerResearchStage,
}); });
//# sourceMappingURL=BuyerResearchStage.js.map